import { County } from "./county";

export class Section {
    sectionId: number;
    sectionTitle: string;
    county: County;

    constructor() {
        this.county = new County();
    }
}